import React, { useEffect, useState } from "react";
import axios from "axios";
import "../portfolioDetails.css";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
);
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const API = "${BASE_URL}/backtest/strategy-details/SGM-focus360monthlycore";

const PortfolioDetails = () => {
  const [data, setData] = useState(null);
  const [graphOpen, setGraphOpen] = useState(false);
  const [descOpen, setDescOpen] = useState(false);
  const [insightOpen, setInsightOpen] = useState(true);

  useEffect(() => {
    const token = sessionStorage.getItem("jwtToken");

    axios
      .get(API, {
        headers: {
          Authorization: `Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI4Njg4NjA0NTE2Iiwicm9sZSI6IlJPTEVfQURNSU4iLCJleHAiOjE3NzQzMjkyODUsImlhdCI6MTc3NDMyNTY4NX0.uuzzx1jeuzot06AOJWNat2nOQqBq0CeyKAfpW1pHi8A`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setData(res.data.data.strategyDetails);
      })
      .catch((err) => {
        console.error("API Error", err);
      });
  }, []);

  if (!data) return <div>Loading...</div>;

  const highlights = data.strategyHighlights;
  const config = data.homeScreenSelectedConfig;

  const graphData = {
    labels: data.graphData?.strategyDataPointsList?.map((d) => d.date),
    datasets: [
      {
        label: "Strategy",
        data: data.graphData?.strategyDataPointsList?.map((d) => d.percentage),
        borderColor: "#f5a623",
        tension: 0.4,
      },
      {
        label: "Benchmark",
        data: data.graphData?.relativeDataPoints?.map((d) => d.percentage),
        borderColor: "#999",
        tension: 0.4,
      },
    ],
  };

  return (
    <div className="strategy-page">
      <div className="header">Focus360 Velocity</div>

      <div className="tabs">
        <span className="active">Overview</span>
        <span>Live Trades</span>
        <span>Past Performance</span>
      </div>

      <div className="section">
        <div
          className="section-header"
          onClick={() => setGraphOpen(!graphOpen)}
        >
          Graph
        </div>

        {graphOpen && (
          <div className="graph-box">
            <Line data={graphData} />
            <div className="range-buttons">
              <button className="active">1Y</button>
              <button>3Y</button>
              <button>5Y</button>
              <button>Max</button>
            </div>
          </div>
        )}
      </div>

      <div className="video-section">
        <a href={highlights.videoLink} target="_blank" rel="noreferrer">
          Watch Model Portfolio Explainer Video
        </a>
      </div>

      <div className="section">
        <div className="section-header" onClick={() => setDescOpen(!descOpen)}>
          Strategy Description
        </div>

        {descOpen && (
          <p className="description">{highlights.strategyDescription}</p>
        )}
      </div>

      <div className="download">
        <a href={highlights.strategyDetails} target="_blank" rel="noreferrer">
          Download Presentation
        </a>
      </div>

      <div className="section">
        <div
          className="section-header"
          onClick={() => setInsightOpen(!insightOpen)}
        >
          Insights
        </div>

        {insightOpen && (
          <div className="insights-card">
            <div>
              <h3>{data.xirr}%</h3>
              <span>CAGR</span>
            </div>

            <div>
              <h3>{config?.rebalance === "1" ? "Monthly" : "Quarterly"}</h3>
              <span>Rebalancing</span>
            </div>

            <div>
              <h3>{config?.universe}</h3>
              <span>Universe</span>
            </div>

            <div>
              <h3>₹{Math.round(data.netReturns)}</h3>
              <span>Capital Growth</span>
            </div>

            <div>
              <h3>{config?.numberOfStocks}</h3>
              <span>Max Stocks</span>
            </div>

            <div>
              <h3>{highlights.totalTrades}</h3>
              <span>Total Trades</span>
            </div>

            <div>
              <h3>{highlights.winningTrades}</h3>
              <span>Win Trades</span>
            </div>

            <div>
              <h3>{highlights.losingTrades}</h3>
              <span>Loss Trades</span>
            </div>

            <div>
              <h3>{highlights.averageWinningTrades}%</h3>
              <span>Avg Win %</span>
            </div>

            <div>
              <h3>{highlights.averageLosingTrades}%</h3>
              <span>Avg Loss %</span>
            </div>

            <div>
              <h3>{data.drawdown?.drawDownInPercentage}%</h3>
              <span>Max Drawdown</span>
            </div>
          </div>
        )}
      </div>

      <button className="subscribe-btn">Subscribe</button>
    </div>
  );
};

export default PortfolioDetails;
